'use client';

import { Loader2 } from 'lucide-react';

import { formatKgCo2e } from '../lib/activity-form-helpers';
export interface EstimateSummary {
  totalCo2eKg?: number | null | undefined;
  locationBasedCo2eKg?: number | null | undefined;
  marketBasedCo2eKg?: number | null | undefined;
}

interface ActivityFormEstimateInlineProps {
  estimate: EstimateSummary | null;
  loading: boolean;
  blockedReason?: string | null;
  isScope2?: boolean;
}

export function ActivityFormEstimateInline({
  estimate,
  loading,
  blockedReason,
  isScope2,
}: ActivityFormEstimateInlineProps) {
  if (loading) {
    return (
      <div
        className="flex items-center gap-1.5 text-sm text-muted-foreground"
        data-testid="estimate-inline-loading"
      >
        <Loader2 className="h-3 w-3 animate-spin" />
        <span>Calculating estimate...</span>
      </div>
    );
  }

  if (blockedReason) {
    return (
      <div
        className="text-xs text-muted-foreground"
        data-testid="estimate-inline-blocked"
      >
        {blockedReason}
      </div>
    );
  }

  if (!estimate) {
    return null;
  }

  if (isScope2 && (estimate.locationBasedCo2eKg != null || estimate.marketBasedCo2eKg != null)) {
    return (
      <div className="space-y-0.5" data-testid="estimate-inline-scope2">
        {estimate.locationBasedCo2eKg != null && (
          <div className="flex items-center gap-1.5 text-sm">
            <span className="font-medium text-emerald-700">
              ~{formatKgCo2e(estimate.locationBasedCo2eKg)}
            </span>
            <span className="text-xs text-muted-foreground">(location-based)</span>
          </div>
        )}
        {estimate.marketBasedCo2eKg != null && (
          <div className="flex items-center gap-1.5 text-sm">
            <span className="font-medium text-blue-700">
              ~{formatKgCo2e(estimate.marketBasedCo2eKg)}
            </span>
            <span className="text-xs text-muted-foreground">(market-based)</span>
          </div>
        )}
      </div>
    );
  }

  if (estimate.totalCo2eKg != null) {
    return (
      <div
        className="flex items-center gap-1.5 text-sm"
        data-testid="estimate-inline"
      >
        <span className="font-medium text-emerald-700">
          ~{formatKgCo2e(estimate.totalCo2eKg)}
        </span>
      </div>
    );
  }

  return null;
}
